import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Tabs, Alert, Table, Avatar } from 'antd'
import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_talent_tab, req_single_cms_learnmap_talent_plan_course } from '../../api'

const { TabPane } = Tabs
class CoursemapStudentCoursePlan extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        detailsloading: false,
        defaultKey: null,
        talents: [],
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ items: [], loading: true })
        const result = await req_single_cms_school_student(userCode, token)
        if (result) {
            const yearplan = await req_single_cms_learnmap_yearplan(result, token)
            //console.log(yearplan)
            if (yearplan) {
                const tab = await req_single_cms_learnmap_talent_tab(userCode, token)
                if (tab) {
                    if (tab.total > 0) {
                        const talents = tab.data
                        const defaultKey = talents[0].nidTalent
                        this.setState({ talents, defaultKey })
                        this.tab_change(defaultKey)
                    }
                    this.setState({ loading: false })
                } else {
                    this.setState({ loading: false })
                }
            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }
    }

    // 數據配置處理 //////////////////////////////////////////////

    set_label_text = (key, value) => {
        let data = ''
        switch (key) {
            case 'GRADE':
                switch (value) {
                    case '1':
                        data = '一年級'
                        break
                    case '2':
                        data = '二年級'
                        break
                    case '3':
                        data = '三年級'
                        break
                    case '4':
                        data = '四年級'
                        break
                    case '5':
                        data = '五年級'
                        break
                    case '6':
                        data = '六年級'
                        break
                    case '7':
                        data = '七年級'
                        break
                    default:
                }
                break;
            case 'SEMESTER':
                switch (value) {
                    case '1':
                        data = '上學期'
                        break
                    case '2':
                        data = '下學期'
                        break
                    default:
                }
                break
            default:

        }
        return data

    }

    // 介面互動處理 //////////////////////////////////////////////
    tab_change = async (key) => {
        const { talents } = this.state
        const { token } = this.props.user
        const talent = talents.find(x => x.nidTalent === key)
        //console.log(talent)
        const tagret = {
            gidLearnMapMeta: talent.gidLearnMapMeta,
            nidLearnMapMeta: talent.nidLearnMapMeta,
            gidTalent: talent.gidTalent,
            nidTalent: talent.nidTalent
        }
        this.setState({ items: [], detailsloading: true })
        const result = await req_single_cms_learnmap_talent_plan_course(tagret, token)
        if (result) {
            if (result.total > 0) {
                const rows = result.data
                let items = rows.reduce((r, a) => {
                    r[a.studentGrade] = [...r[a.studentGrade] || [], a];
                    return r;
                }, {});

                this.setState({ items, detailsloading: false })
            }
        } else {
            this.setState({ detailsloading: false })
        }
    }

    /////////////////////////////////////////////////////////////    
    render() {
        const { loading, items, talents, defaultKey } = this.state
        const tabPanes = talents.length > 0 ? talents.map((row, idx) => <TabPane tab={row.talentTwName} key={row.nidTalent}>
            <Alert key={row.nidTalent}
                description={row.talentDescription}
                type="success"
                showIcon
            /></TabPane>) : ''
        const columns = [
            {
                title: '學期',
                width: 20,
                responsive: ['md'],
                render: (item) => {
                    const { studentSemester } = item
                    return (
                        <div className='text-center' style={{
                            color: studentSemester === '1' ? 'blue' : 'Indigo',
                        }}>
                            {this.set_label_text('SEMESTER', studentSemester)}
                        </div>
                    )
                },
            },
            {
                title: '課程類別',
                dataIndex: 'courseCatalog',
                width: 30,
                responsive: ['md'],
            },
            {
                title: '課程代碼',
                dataIndex: 'courseCode',
                width: 30,
                responsive: ['md'],
            },
            {
                title: '課程名稱',
                dataIndex: 'courseTwName',
                width: 60,
            },
            {
                title: '必(選)修',
                dataIndex: 'courseChooseType',
                width: 30,
                responsive: ['md'],
            },
            {
                title: '學分',
                dataIndex: 'courseCredit',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '適用本人才',
                width: 25,
                render: (item) => {
                    const { isSelected } = item
                    return (
                        <div className='text-center'>
                            <Avatar
                                style={{
                                    backgroundColor: isSelected === 'Y' ? 'green' : 'red',
                                }}
                                icon={isSelected === 'Y' ? <i className="fas fa-check"></i> : <i className="fas fa-minus"></i>}
                            />
                        </div>
                    )
                },
            },

        ]

        const htmlItems = talents.length > 0 ? (<>
            <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                {tabPanes}
            </Tabs>
            <Card>
                <Tabs defaultActiveKey="1" >
                    {Object.keys(items).map((item, i) => (
                        <TabPane tab={this.set_label_text('GRADE', item)} key={i}>
                            <Table
                                bordered
                                style={{ width: '99%' }}
                                scroll={{ y: 500 }}
                                loading={loading}
                                rowKey='id'
                                dataSource={items[item]}
                                pagination={false}
                                columns={columns}
                            />
                        </TabPane>
                    ))}
                </Tabs>
            </Card>
        </>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)

        return (
            <>
                {loading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    {htmlItems}
                </>)}
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCoursePlan)